import React from 'react';
import CustomModal from '../../../../../components/Modal/CustomModal';
import ScheduleTime from '../SubComponents/ScheduleTime';
import AddEditDeptScheduleApp from '../Functionality/AddEditDeptScheduleApp';
import { MIN_MAX_VALUES_MANAGE } from '../Models/Model';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param show
 * @param onHide
 * @returns {JSX.Element}
 * @constructor
 */
const AddEditDeptSchedule = ({ show, onHide, itemSelect, title }) => {

    const { item, handleAddEdit, handleChange, disabled, emptyFields, isValidTime,
        isValidMealTime, isValidFoodsPerDay} =
        AddEditDeptScheduleApp({ onHide, itemSelect });

    return (
        <CustomModal
            show={show}
            onHide={onHide}
            onConfirm={() => {
                handleAddEdit();
            }}
            title={title}
            size='lg'
            buttonConfirm='confirm'
        >
            <div className='row'>
                <ScheduleTime
                    item={item}
                    disabled={disabled}
                    onChange={handleChange}
                    emptyFields={emptyFields}
                    isValidTime={isValidTime}
                    isValidMealTime={isValidMealTime}
                    isValidFoodsPerDay={isValidFoodsPerDay}
                    rangeMealTime={MIN_MAX_VALUES_MANAGE.MEALTIME}
                    rangeFoodsPerDay={MIN_MAX_VALUES_MANAGE.FOOD_PER_DAY}
                />
            </div>

        </CustomModal>
    );
};

export default AddEditDeptSchedule;
